// 引入创建配置函数
// 引入创建配置函数
import {
  fwzyQlxxExForm,
  fwbgQlxxForm,
  dyscQlxxForm,
  bzhzQlxxForm,
  fwzxQlxxForm,
  fwcfQlxxForm,
  fwcfQlxxExForm,
  fwjfQlxxExForm,
  mmygQlxxForm,
  mmygQlxxFormN,
  fwscQlxxForm,
  mmygQlxxExForm,
  clfmmygQlxxExForm,
  mmygzxQlxxExForm,
  dyygQlxxExForm,
  dyygQlxxExForm1,
  dyygQlxxExForm2,
  dyygzxQlxxExForm,
  dybgQlxxExForm,
  ybdyqscQlxxExForm,
  zjdyqscQlxxExForm,
  fwzyycQlxxFormN200104,
  fwscQlxxDialogForm,
  qlxxDialogForm,
  ygdyzxQlxxExForm,
  otherqlxxDialogForm,
  mmygqlxxDialogForm,
  fwcfxxExForm,
  clfmmygqlxxDialogForm,
  mmygqlxxDialogFormN,
  tdbgqlxxDialogForm,
  tddyqlxxDialogForm,
  tddyqscQlxxForm,
  tddyqzxQlxxForm,
  // fwzyycQlxxExForm,
  zbwzyQlxxExForm,
  fwzydjNewDialogForm,
  clfQlxxForm,
  fwzyYcxxExForm,
  ygNewqlxxDialogForm,
  zbwqlxxDialogForm,
} from './qlxxFormConfig';
import {
  qlrDialogForm,
  cyrqlrDialogForm,
  qlrYBDYSCDialogForm,
  ywrDialogForm,
  ywrYGMMDialogForm,
  zwrDialogForm,
  fwzyQlrDialogForm,
  fwzyNewQlrDialogForm,
  mfYwrDialogForm,
  fwsyqzbwYwrDialogForm,
  cfywrDialogForm,
  cfsqrDialogForm,
  mfSYGYwrDialogForm,
  ygzwrDialogForm,
} from './sqrDialogFormConfig';
import { familyGroupColumn } from './familyColumnConfig';
// import createTableConfig from '@public/applyConfig/createTableConfig';
import column from './tableColumnConfig';
const copyData = (form) => {
  return form.map((e) => {
    if (typeof e === 'object') {
      return Object.assign({}, e);
    } else {
      return e;
    }
  });
};
export const sqbConfig = [
  {
    // 一般抵押权首次
    name: '抵押权首次登记',
    code: 'N100301',
    data: [
      {
        name: '抵押权首次登记',
        code: 'N100301',
        config: [
          {
            type: 'table-sqr',
            category: '4',
            tableTitle: '抵押权人(银行)',
            tableColumnConfig: column.qlrTable,
            dialogFormConfig: qlrYBDYSCDialogForm, // 表单配置
          },
          {
            type: 'table-sqr',
            category: '5',
            tableTitle: '抵押人(房屋所有者)',
            tableColumnConfig: column.ywrTable,
            dialogFormConfig: ywrDialogForm, // 表单配置
          },
          {
            type: 'table-sqr',
            category: '6',
            tableTitle: '债务人',
            tableColumnConfig: column.zwrTable,
            dialogFormConfig: zwrDialogForm, // 表单配置
          },
          {
            type: 'table-qlxx',
            key: 'qlxxExMhs',
            tableTitle: '不动产情况(单位:平方米、万元)',
            tableColumnConfig: column.dyscqlxxTable,
            dialogFormConfig: otherqlxxDialogForm, // 表单配置
          },
          {
            type: 'form',
            key: 'qlxxExMhs',
            tableTitle: '不动产情况(单位:平方米、万元)',
            formConfig: dyscQlxxForm,
          },
          {
            type: 'form',
            key: 'qlxxEx',
            tableTitle: '抵押信息(单位:平方米、万元)',
            formConfig: ybdyqscQlxxExForm, // 表单配置
          },
        ],
      },
    ],
  },
  {
    name: '房屋查封登记',
    code: 'N100402',
    data: [
      {
        name: '房屋查封登记',
        code: 'N100402',
        config: [
          {
            type: 'table-sqr',
            category: '12',
            tableTitle: '查封对象',
            tableColumnConfig: column.ywrTable,
            dialogFormConfig: cfywrDialogForm, // 表单配置
          },
          {
            type: 'table-qlxx',
            key: 'qlxxExMhs',
            tableTitle: '不动产情况(单位:平方米、万元)',
            tableColumnConfig: column.qlxxTable,
            dialogFormConfig: fwcfQlxxForm, // 表单配置
          },
          {
            type: 'form',
            key: 'qlxxExMhs',
            tableTitle: '不动产情况(单位:平方米、万元)',
            formConfig: fwcfQlxxForm,
          },
          {
            type: 'form',
            key: 'qlxxEx',
            tableTitle: '查封信息(单位:平方米、万元)',
            formConfig: fwcfxxExForm, // 表单配置
          },
        ],
      },
    ],
  },
  {
    // 抵押权首次（土地）
    name: '抵押权首次（土地）',
    code: 'N200111',
    data: [
      {
        name: '抵押权首次（土地）',
        code: 'N200111',
        config: [
          {
            type: 'table-sqr',
            category: '4',
            tableTitle: '抵押权人',
            tableColumnConfig: column.qlrTable,
            dialogFormConfig: qlrDialogForm, // 表单配置
          },
          {
            type: 'table-sqr',
            category: '5',
            tableTitle: '抵押人(土地所有者)',
            tableColumnConfig: column.ywrTable,
            dialogFormConfig: ywrDialogForm, // 表单配置
          },
          {
            type: 'table-sqr',
            category: '6',
            tableTitle: '债务人(借款者)',
            tableColumnConfig: column.zwrTable,
            dialogFormConfig: zwrDialogForm, // 表单配置
          },
          {
            type: 'table-qlxx',
            key: 'qlxxExMhs',
            tableTitle: '不动产情况(单位:平方米、万元)',
            tableColumnConfig: column.tddyqQlxxTable,
            dialogFormConfig: tddyqlxxDialogForm, // 表单配置
          },
          {
            type: 'form',
            key: 'qlxxExMhs',
            tableTitle: '不动产情况(单位:平方米、万元)',
            formConfig: tddyqlxxDialogForm,
          },
          {
            type: 'form',
            key: 'qlxxEx',
            tableTitle: '抵押信息(单位:平方米、万元)',
            formConfig: tddyqscQlxxForm, // 表单配置
          },
        ],
      },
    ],
  },
  {
    // 抵押权注销
    name: '抵押权注销',
    code: 'N400301',
    data: [
      {
        name: '抵押权注销',
        code: 'N400301',
        config: [
          {
            type: 'table-sqr',
            category: '4',
            tableTitle: '抵押权人(银行)',
            tableColumnConfig: column.qlrTable,
            dialogFormConfig: qlrDialogForm, // 表单配置
          },
          {
            type: 'table-sqr',
            category: '5',
            tableTitle: '抵押人(房屋所有者)',
            tableColumnConfig: column.ywrTable,
            dialogFormConfig: ywrDialogForm, // 表单配置
          },
          {
            type: 'table-sqr',
            category: '6',
            tableTitle: '债务人',
            tableColumnConfig: column.zwrTable,
            dialogFormConfig: zwrDialogForm, // 表单配置
          },
          {
            type: 'table-qlxx',
            key: 'qlxxExMhs',
            tableTitle: '不动产情况(单位:平方米、万元)',
            tableColumnConfig: column.dyscqlxxTable,
            dialogFormConfig: otherqlxxDialogForm, // 表单配置
          },
          {
            type: 'form',
            key: 'qlxxExMhs',
            tableTitle: '不动产情况(单位:平方米、万元)',
            formConfig: fwbgQlxxForm,
          },
          {
            type: 'form',
            key: 'qlxxEx',
            tableTitle: '抵押信息(单位:平方米、万元)',
            formConfig: dyygzxQlxxExForm, // 表单配置
          },
        ],
      },
    ],
  },
  {
    // 土地变更
    name: '土地变更',
    code: 'N300103',
    data: [
      {
        name: '土地变更',
        code: 'N300103',
        config: [
          {
            type: 'table-sqr',
            category: '2',
            tableTitle: '申请人',
            tableColumnConfig: column.qlrTable,
            dialogFormConfig: qlrDialogForm, // 表单配置
          },
          {
            type: 'table-qlxx',
            key: 'qlxxExMhs',
            tableTitle: '不动产情况(单位:平方米、万元)',
            tableColumnConfig: column.tddyqQlxxTable,
            dialogFormConfig: tdbgqlxxDialogForm, // 表单配置
          },
          {
            type: 'form',
            key: 'qlxxExMhs',
            tableTitle: '不动产情况(单位:平方米、万元)',
            formConfig: tdbgqlxxDialogForm,
          },
          {
            type: 'form',
            key: 'qlxxEx',
            tableTitle: '其它信息',
            formConfig: fwzyQlxxExForm, // 表单配置
          },
        ],
      },
    ],
  },
  {
    // 抵押权注销（土地）
    name: '抵押权注销（土地）',
    code: 'N100303',
    data: [
      {
        name: '抵押权注销（土地）',
        code: 'N100303',
        config: [
          {
            type: 'table-sqr',
            category: '4',
            tableTitle: '抵押权人',
            tableColumnConfig: column.qlrTable,
            dialogFormConfig: qlrDialogForm, // 表单配置
          },
          {
            type: 'table-sqr',
            category: '5',
            tableTitle: '抵押人(土地所有者)',
            tableColumnConfig: column.ywrTable,
            dialogFormConfig: ywrDialogForm, // 表单配置
          },
          {
            type: 'table-sqr',
            category: '6',
            tableTitle: '债务人(借款者)',
            tableColumnConfig: column.zwrTable,
            dialogFormConfig: zwrDialogForm, // 表单配置
          },
          {
            type: 'table-qlxx',
            key: 'qlxxExMhs',
            tableTitle: '不动产情况(单位:平方米、万元)',
            tableColumnConfig: column.tddyqQlxxTable,
            dialogFormConfig: tddyqlxxDialogForm, // 表单配置
          },
          {
            type: 'form',
            key: 'qlxxExMhs',
            tableTitle: '不动产情况(单位:平方米、万元)',
            formConfig: tddyqlxxDialogForm,
          },
          {
            type: 'form',
            key: 'qlxxEx',
            tableTitle: '抵押信息(单位:平方米、万元)',
            formConfig: tddyqzxQlxxForm, // 表单配置
          },
        ],
      },
    ],
  },
  {
    name: '房屋转移',
    code: 'N200104',
    data: [
      {
        name: '房屋转移',
        code: 'N200104',
        config: [
          {
            type: 'table-sqr',
            category: '0',
            tableTitle: '买方',
            tableColumnConfig: column.qlrTable,
            familyTableConfig: column.familyGroupTable,
            familyColumnConfig: familyGroupColumn,
            dialogFormConfig: fwzyNewQlrDialogForm, // 表单配置
          },
          {
            type: 'table-sqr',
            category: '1',
            tableTitle: '卖方',
            tableColumnConfig: column.ywrTable,
            familyTableConfig: column.familyGroupTable,
            familyColumnConfig: familyGroupColumn,
            dialogFormConfig: mfYwrDialogForm, // 表单配置
          },
          {
            type: 'table-qlxx',
            key: 'qlxxExMhs',
            tableTitle: '不动产情况(单位:平方米、万元)',
            tableColumnConfig: column.qlxxTable,
            dialogFormConfig: fwzyycQlxxFormN200104, // 表单配置
          },
          {
            type: 'form',
            key: 'qlxxExMhs',
            tableTitle: '不动产情况(单位:平方米、万元)',
            formConfig: fwzyycQlxxFormN200104,
          },
          {
            type: 'form',
            key: 'ycxx',
            tableTitle: '一窗信息',
            formConfig: copyData(fwzyYcxxExForm), // 表单配置
          },
          {
            type: 'form',
            key: 'qlxxEx',
            tableTitle: '其它信息',
            formConfig: copyData(fwzyQlxxExForm), // 表单配置
          },
        ],
      },
    ],
  },
  {
    name: '房屋变更',
    code: 'N300104',
    data: [
      {
        name: '房屋变更',
        code: 'N300104',
        config: [
          {
            type: 'table-sqr',
            category: '0',
            tableTitle: '权利人',
            tableColumnConfig: column.qlrTable,
            dialogFormConfig: qlrDialogForm, // 表单配置
          },
          // {
          //   type: 'table-sqr',
          //   category: '1',
          //   tableTitle: '原权利人',
          //   tableColumnConfig: column.ywrTable,
          //   dialogFormConfig: ywrDialogForm // 表单配置
          // },
          {
            type: 'table-qlxx',
            key: 'qlxxExMhs',
            tableTitle: '不动产情况(单位:平方米、万元)',
            tableColumnConfig: column.dyscqlxxTable,
            dialogFormConfig: otherqlxxDialogForm, // 表单配置
          },
          {
            type: 'form',
            key: 'qlxxExMhs',
            tableTitle: '不动产情况(单位:平方米、万元)',
            formConfig: fwbgQlxxForm,
          },
          {
            type: 'form',
            key: 'qlxxEx',
            tableTitle: '其它信息',
            formConfig: fwzyQlxxExForm, // 表单配置
          },
        ],
      },
    ],
  },
  {
    name: '房屋首次',
    code: 'N100104',
    data: [
      {
        name: '房屋首次',
        code: 'N100104',
        config: [
          {
            type: 'table-sqr',
            category: '0',
            tableTitle: '权利人',
            tableColumnConfig: column.qlrTable,
            dialogFormConfig: qlrDialogForm, // 表单配置
          },
          {
            type: 'table-qlxx',
            key: 'qlxxExMhs',
            tableTitle: '不动产情况(单位:平方米、万元)',
            tableColumnConfig: column.fwscQlxxTable,
            dialogFormConfig: fwscQlxxDialogForm, // 表单配置
          },
          {
            type: 'form',
            key: 'qlxxExMhs',
            tableTitle: '不动产情况(单位:平方米、万元)',
            formConfig: fwscQlxxForm,
          },
          {
            type: 'form',
            key: 'qlxxEx',
            tableTitle: '其它信息',
            formConfig: fwzyQlxxExForm, // 表单配置
          },
        ],
      },
    ],
  },
  {
    name: '房屋注销',
    code: 'N400104',
    data: [
      {
        name: '房屋注销',
        code: 'N400104',
        config: [
          {
            type: 'table-sqr',
            category: '0',
            tableTitle: '权利人',
            tableColumnConfig: column.qlrTable,
            dialogFormConfig: qlrDialogForm, // 表单配置
          },
          {
            type: 'table-qlxx',
            key: 'qlxxExMhs',
            tableTitle: '不动产情况(单位:平方米、万元)',
            tableColumnConfig: column.qlxxTable,
            dialogFormConfig: qlxxDialogForm, // 表单配置
          },
          {
            type: 'form',
            key: 'qlxxExMhs',
            tableTitle: '不动产情况(单位:平方米、万元)',
            formConfig: fwzxQlxxForm,
          },
          {
            type: 'form',
            key: 'qlxxEx',
            tableTitle: '其它信息(单位:平方米、万元)',
            formConfig: fwzyQlxxExForm, // 表单配置
          },
        ],
      },
    ],
  },
  {
    name: '房屋查封登记',
    code: 'N100402',
    data: [
      {
        name: '房屋查封登记',
        code: 'N100402',
        config: [
          {
            type: 'table-sqr',
            category: '12',
            tableTitle: '被查封人',
            tableColumnConfig: column.qlrTable,
            dialogFormConfig: cfsqrDialogForm, // 表单配置
          },
          {
            type: 'table-qlxx',
            key: 'qlxxExMhs',
            tableTitle: '不动产情况(单位:平方米、万元)',
            tableColumnConfig: column.qlxxTable,
            dialogFormConfig: qlxxDialogForm, // 表单配置
          },
          {
            type: 'form',
            key: 'qlxxExMhs',
            tableTitle: '不动产情况(单位:平方米、万元)',
            formConfig: fwcfQlxxForm,
          },
          {
            type: 'form',
            key: 'qlxxEx',
            tableTitle: '查封信息(单位:平方米、万元)',
            formConfig: fwcfQlxxExForm, // 表单配置
          },
        ],
      },
    ],
  },
  {
    name: '房屋解封登记',
    code: 'N400402',
    data: [
      {
        name: '房屋解封登记',
        code: 'N400402',
        config: [
          {
            type: 'table-sqr',
            category: '12',
            tableTitle: '被查封人',
            tableColumnConfig: column.qlrTable,
            dialogFormConfig: qlrDialogForm, // 表单配置
          },
          {
            type: 'table-qlxx',
            key: 'qlxxExMhs',
            tableTitle: '不动产情况(单位:平方米、万元)',
            tableColumnConfig: column.qlxxTable,
            dialogFormConfig: qlxxDialogForm, // 表单配置
          },
          {
            type: 'form',
            key: 'qlxxExMhs',
            tableTitle: '不动产情况(单位:平方米、万元)',
            formConfig: fwcfQlxxForm,
          },
          {
            type: 'form',
            key: 'qlxxEx',
            tableTitle: '解封信息(单位:平方米、万元)',
            formConfig: fwjfQlxxExForm, // 表单配置
          },
        ],
      },
    ],
  },
  {
    name: '预售商品房买卖预告登记',
    code: 'N100201',
    data: [
      {
        name: '预售商品房买卖预告登记',
        code: 'N100201',
        config: [
          {
            type: 'table-sqr',
            category: '7',
            tableTitle: '预告权利人(购房者)',
            tableColumnConfig: column.qlrTable,
            dialogFormConfig: qlrDialogForm, // 表单配置
          },
          {
            type: 'table-sqr',
            category: '8',
            tableTitle: '预告义务人(房地产开发商)',
            tableColumnConfig: column.ywrTable,
            dialogFormConfig: ywrYGMMDialogForm, // 表单配置
          },
          {
            type: 'table-qlxx',
            key: 'qlxxExMhs',
            tableTitle: '不动产情况(单位:平方米、万元)',
            tableColumnConfig: column.ygqlxxTableNew,
            dialogFormConfig: ygNewqlxxDialogForm, // 表单配置
          },
          {
            type: 'form',
            key: 'qlxxExMhs',
            tableTitle: '不动产情况(单位:平方米、万元)',
            formConfig: mmygQlxxFormN,
          },
          {
            type: 'form',
            key: 'qlxxEx',
            tableTitle: '预告信息(单位:平方米、万元)',
            formConfig: mmygQlxxExForm, // 表单配置
          },
        ],
      },
    ],
  },
  {
    name: '存量房买卖预告登记',
    code: 'N123412',
    data: [
      {
        name: '存量房买卖预告登记',
        code: 'N123412',
        config: [
          {
            type: 'table-sqr',
            category: '7',
            tableTitle: '预告权利人',
            tableColumnConfig: column.qlrTable,
            dialogFormConfig: qlrDialogForm, // 表单配置
          },
          {
            type: 'table-sqr',
            category: '8',
            tableTitle: '预告义务人',
            tableColumnConfig: column.ywrTable,
            dialogFormConfig: ywrDialogForm, // 表单配置
          },
          {
            type: 'table-qlxx',
            key: 'qlxxExMhs',
            tableTitle: '不动产情况(单位:平方米、万元)',
            tableColumnConfig: column.dyscqlxxTable,
            dialogFormConfig: clfmmygqlxxDialogForm, // 表单配置
          },
          {
            type: 'form',
            key: 'qlxxExMhs',
            tableTitle: '不动产情况(单位:平方米、万元)',
            formConfig: copyData(clfQlxxForm),
          },
          {
            type: 'form',
            key: 'qlxxEx',
            tableTitle: '预告信息(单位:平方米、万元)',
            formConfig: clfmmygQlxxExForm, // 表单配置
          },
        ],
      },
    ],
  },
  {
    name: '预售商品房买卖预告注销登记',
    code: 'N360000',
    data: [
      {
        name: '预售商品房买卖预告注销登记',
        code: 'N360000',
        config: [
          {
            type: 'table-sqr',
            category: '7',
            tableTitle: '预告权利人(购房者)',
            tableColumnConfig: column.qlrTable,
            dialogFormConfig: qlrDialogForm, // 表单配置
          },
          {
            type: 'table-sqr',
            category: '8',
            tableTitle: '预告义务人(房地产开发商)',
            tableColumnConfig: column.ywrTable,
            dialogFormConfig: ywrDialogForm, // 表单配置
          },
          {
            type: 'table-qlxx',
            key: 'qlxxExMhs',
            tableTitle: '不动产情况(单位:平方米、万元)',
            tableColumnConfig: column.ygqlxxTable,
            dialogFormConfig: mmygqlxxDialogForm, // 表单配置A
          },
          {
            type: 'form',
            key: 'qlxxExMhs',
            tableTitle: '不动产情况(单位:平方米、万元)',
            formConfig: mmygQlxxFormN,
          },
          {
            type: 'form',
            key: 'qlxxEx',
            tableTitle: '预告信息(单位:平方米、万元)',
            formConfig: mmygzxQlxxExForm, // 表单配置
          },
        ],
      },
    ],
  },
  {
    name: '预售商品房抵押预告登记',
    code: 'N100203',
    data: [
      {
        name: '预售商品房抵押预告登记',
        code: 'N100203',
        config: [
          {
            type: 'table-sqr',
            category: '9',
            tableTitle: '预告抵押权人(银行)',
            tableColumnConfig: column.qlrTable,
            dialogFormConfig: qlrDialogForm, // 表单配置
          },
          {
            type: 'table-sqr',
            category: '10',
            tableTitle: '预告抵押人(购房者)',
            tableColumnConfig: column.ywrTable,
            dialogFormConfig: ywrDialogForm, // 表单配置
          },
          {
            type: 'table-sqr',
            category: '11',
            tableTitle: '预告债务人(借款者)',
            tableColumnConfig: column.zwrTable,
            dialogFormConfig: zwrDialogForm, // 表单配置
          },
          {
            type: 'table-qlxx',
            key: 'qlxxExMhs',
            tableTitle: '不动产情况(单位:平方米、万元)',
            tableColumnConfig: column.ygqlxxTable,
            dialogFormConfig: mmygqlxxDialogFormN, // 表单配置
          },
          {
            type: 'form',
            key: 'qlxxExMhs',
            tableTitle: '不动产情况(单位:平方米、万元)',
            formConfig: mmygQlxxForm,
          },
          {
            type: 'form',
            key: 'qlxxEx',
            tableTitle: '抵押信息(单位:平方米、万元)',
            formConfig: dyygQlxxExForm, // 表单配置
          },
        ],
      },
    ],
  },
  {
    name: '预售商品房抵押权预告注销',
    code: 'N300126',
    data: [
      {
        name: '预售商品房抵押权预告注销',
        code: 'N300126',
        config: [
          {
            type: 'table-sqr',
            category: '9',
            tableTitle: '预告抵押权人(银行)',
            tableColumnConfig: column.qlrTable,
            dialogFormConfig: qlrDialogForm, // 表单配置
          },
          {
            type: 'table-sqr',
            category: '10',
            tableTitle: '预告抵押人(购房者)',
            tableColumnConfig: column.ywrTable,
            dialogFormConfig: ywrDialogForm, // 表单配置
          },
          {
            type: 'table-sqr',
            category: '11',
            tableTitle: '预告债务人(借款者)',
            tableColumnConfig: column.zwrTable,
            dialogFormConfig: zwrDialogForm, // 表单配置
          },
          {
            type: 'table-qlxx',
            key: 'qlxxExMhs',
            tableTitle: '不动产情况(单位:平方米、万元)',
            tableColumnConfig: column.ygqlxxTable,
            dialogFormConfig: mmygqlxxDialogFormN, // 表单配置
          },
          {
            type: 'form',
            key: 'qlxxExMhs',
            tableTitle: '不动产情况(单位:平方米、万元)',
            formConfig: mmygQlxxForm,
          },
          {
            type: 'form',
            key: 'qlxxEx',
            tableTitle: '抵押信息(单位:平方米、万元)',
            formConfig: ygdyzxQlxxExForm, // 表单配置
          },
        ],
      },
    ],
  },
  {
    name: '抵押权变更',
    code: 'N300301',
    data: [
      {
        name: '抵押权变更',
        code: 'N300301',
        config: [
          {
            type: 'table-sqr',
            category: '4',
            tableTitle: '抵押权人',
            tableColumnConfig: column.qlrTable,
            dialogFormConfig: qlrDialogForm, // 表单配置
          },
          {
            type: 'table-sqr',
            category: '5',
            tableTitle: '抵押人',
            tableColumnConfig: column.ywrTable,
            dialogFormConfig: ywrDialogForm, // 表单配置
          },
          {
            type: 'table-sqr',
            category: '6',
            tableTitle: '债务人(借款者)',
            tableColumnConfig: column.zwrTable,
            dialogFormConfig: zwrDialogForm, // 表单配置
          },
          {
            type: 'table-qlxx',
            key: 'qlxxExMhs',
            tableTitle: '不动产情况(单位:平方米、万元)',
            tableColumnConfig: column.dyscqlxxTable,
            dialogFormConfig: otherqlxxDialogForm, // 表单配置
          },
          {
            type: 'form',
            key: 'qlxxExMhs',
            tableTitle: '不动产情况(单位:平方米、万元)',
            formConfig: fwbgQlxxForm,
          },
          {
            type: 'form',
            key: 'qlxxEx',
            tableTitle: '抵押信息(单位:平方米、万元)',
            formConfig: dybgQlxxExForm, // 表单配置
          },
        ],
      },
    ],
  },
  {
    name: '房屋所有权变更登记+房屋所有权转移登记',
    code: 'H999003',
    data: [
      {
        name: '房屋变更',
        code: 'N300104',
        config: [
          {
            type: 'table-sqr',
            category: '0',
            tableTitle: '权利人',
            tableColumnConfig: column.qlrTable,
            dialogFormConfig: qlrDialogForm, // 表单配置
          },
          // {
          //   type: 'table-sqr',
          //   category: '1',
          //   tableTitle: '原权利人',
          //   tableColumnConfig: column.ywrTable,
          //   dialogFormConfig: ywrDialogForm // 表单配置
          // },
          {
            type: 'table-qlxx',
            key: 'qlxxExMhs',
            tableTitle: '不动产情况(单位:平方米、万元)',
            tableColumnConfig: column.dyscqlxxTable,
            dialogFormConfig: otherqlxxDialogForm, // 表单配置
          },
          {
            type: 'form',
            key: 'qlxxExMhs',
            tableTitle: '不动产情况(单位:平方米、万元)',
            formConfig: copyData(fwbgQlxxForm),
          },
          {
            type: 'form',
            key: 'qlxxEx',
            tableTitle: '其它信息',
            formConfig: copyData(fwzyQlxxExForm), // 表单配置
          },
        ],
      },
      {
        name: '房屋转移',
        code: 'N200104',
        config: [
          {
            type: 'table-sqr',
            category: '0',
            tableTitle: '买方',
            tableColumnConfig: column.qlrTable,
            familyTableConfig: column.familyGroupTable,
            familyColumnConfig: familyGroupColumn,
            dialogFormConfig: fwzyQlrDialogForm, // 表单配置
          },
          {
            type: 'table-sqr',
            category: '1',
            tableTitle: '卖方',
            tableColumnConfig: column.ywrTable,
            familyTableConfig: column.familyGroupTable,
            familyColumnConfig: familyGroupColumn,
            dialogFormConfig: mfYwrDialogForm, // 表单配置
          },
          {
            type: 'table-qlxx',
            key: 'qlxxExMhs',
            tableTitle: '不动产情况(单位:平方米、万元)',
            tableColumnConfig: column.qlxxTable,
            dialogFormConfig: fwzydjNewDialogForm, // 表单配置
          },
          {
            type: 'form',
            key: 'qlxxExMhs',
            tableTitle: '不动产情况(单位:平方米、万元)',
            formConfig: copyData(fwzydjNewDialogForm),
          },
          {
            type: 'form',
            key: 'ycxx',
            tableTitle: '一窗信息',
            formConfig: copyData(fwzyYcxxExForm), // 表单配置
          },
          {
            type: 'form',
            key: 'qlxxEx',
            tableTitle: '其它信息',
            formConfig: copyData(fwzyQlxxExForm), // 表单配置
          },
        ],
      },
    ],
  },
  {
    name: '房屋所有权转移登记+抵押权首次登记',
    code: 'H999002',
    data: [
      {
        name: '房屋转移',
        code: 'N200104',
        config: [
          {
            type: 'table-sqr',
            category: '0',
            tableTitle: '买方',
            tableColumnConfig: column.qlrTable,
            familyTableConfig: column.familyGroupTable,
            familyColumnConfig: familyGroupColumn,
            dialogFormConfig: fwzyQlrDialogForm, // 表单配置
          },
          {
            type: 'table-sqr',
            category: '1',
            tableTitle: '卖方',
            tableColumnConfig: column.ywrTable,
            familyTableConfig: column.familyGroupTable,
            familyColumnConfig: familyGroupColumn,
            dialogFormConfig: fwsyqzbwYwrDialogForm, // 表单配置
          },
          {
            type: 'table-qlxx',
            key: 'qlxxExMhs',
            tableTitle: '不动产情况(单位:平方米、万元)',
            tableColumnConfig: column.zbwqlxxTableNew,
            dialogFormConfig: zbwqlxxDialogForm, // 表单配置
          },
          {
            type: 'form',
            key: 'qlxxExMhs',
            tableTitle: '不动产情况(单位:平方米、万元)',
            formConfig: zbwqlxxDialogForm,
          },
          {
            type: 'form',
            key: 'qlxxEx',
            tableTitle: '权利信息',
            formConfig: copyData(zbwzyQlxxExForm), // 表单配置
          },
          {
            type: 'form',
            key: 'ycxx',
            tableTitle: '一窗信息',
            formConfig: copyData(fwzyYcxxExForm), // 表单配置
          },
        ],
      },
      {
        name: '抵押权首次登记',
        code: 'N100301',
        config: [
          {
            type: 'table-sqr',
            category: '4',
            tableTitle: '抵押权人(银行)',
            tableColumnConfig: column.qlrTable,
            dialogFormConfig: cyrqlrDialogForm, // 表单配置
          },
          // {
          //   type: 'table-sqr',
          //   category: '5',
          //   tableTitle: '抵押人(房屋所有者)',
          //   tableColumnConfig: column.ywrTable,
          //   dialogFormConfig: ywrDialogForm // 表单配置
          // },
          {
            type: 'table-sqr',
            category: '6',
            tableTitle: '债务人',
            tableColumnConfig: column.zwrTable,
            dialogFormConfig: ygzwrDialogForm, // 表单配置
          },
          // {
          //   type: 'table-qlxx',
          //   key: 'qlxxExMhs',
          //   tableTitle: '不动产情况(单位:平方米、万元)',
          //   tableColumnConfig: column.dyscqlxxTable,
          //   dialogFormConfig: otherqlxxDialogForm // 表单配置
          // },
          // {
          //   type: 'form',
          //   key: 'qlxxExMhs',
          //   tableTitle: '不动产情况(单位:平方米、万元)',
          //   formConfig: fwbgQlxxForm
          // },
          {
            type: 'form',
            key: 'qlxxEx',
            tableTitle: '抵押信息(单位:平方米、万元)',
            formConfig: ybdyqscQlxxExForm, // 表单配置
          },
        ],
      },
    ],
  },
  {
    name: '预售商品房买卖预告登记+预售商品房抵押预告登记',
    code: 'H999001',
    data: [
      {
        name: '预售商品房买卖预告登记',
        code: 'N100201',
        config: [
          {
            type: 'table-sqr',
            category: '7',
            tableTitle: '预告权利人(购房者)',
            tableColumnConfig: column.qlrTable,
            dialogFormConfig: qlrDialogForm, // 表单配置
          },
          {
            type: 'table-sqr',
            category: '8',
            tableTitle: '预告义务人(房地产开发商)',
            tableColumnConfig: column.ywrTable,
            dialogFormConfig: mfSYGYwrDialogForm, // 表单配置
          },
          {
            type: 'table-qlxx',
            key: 'qlxxExMhs',
            tableTitle: '不动产情况(单位:平方米、万元)',
            tableColumnConfig: column.ygqlxxTableNew,
            dialogFormConfig: ygNewqlxxDialogForm, // 表单配置
          },
          {
            type: 'form',
            key: 'qlxxExMhs',
            tableTitle: '不动产情况(单位:平方米、万元)',
            formConfig: mmygQlxxFormN,
          },
          {
            type: 'form',
            key: 'qlxxEx',
            tableTitle: '预告抵押权利信息(单位:平方米、万元)',
            formConfig: dyygQlxxExForm1, // 表单配置
          },
        ],
      },
      {
        name: '预售商品房抵押预告登记',
        code: 'N100203',
        config: [
          {
            type: 'table-sqr',
            category: '9',
            tableTitle: '预告抵押权人(银行)',
            tableColumnConfig: column.qlrTable,
            dialogFormConfig: qlrYBDYSCDialogForm, // 表单配置
          },
          {
            type: 'table-sqr',
            category: '11',
            tableTitle: '预告债务人(借款者)',
            tableColumnConfig: column.zwrTable,
            dialogFormConfig: ygzwrDialogForm, // 表单配置
          },
          {
            type: 'form',
            key: 'qlxxEx',
            tableTitle: '抵押信息(单位:平方米、万元)',
            formConfig: dyygQlxxExForm2, // 表单配置
          },
        ],
      },
    ],
  },
  {
    // 在建工程抵押首次
    name: '在建工程抵押首次',
    code: 'N300099',
    data: [
      {
        name: '在建工程抵押首次',
        code: 'N300099',
        config: [
          {
            type: 'table-sqr',
            category: '4',
            tableTitle: '抵押权人(银行)',
            tableColumnConfig: column.qlrTable,
            dialogFormConfig: qlrDialogForm, // 表单配置
          },
          {
            type: 'table-sqr',
            category: '5',
            tableTitle: '抵押人(房屋所有者)',
            tableColumnConfig: column.ywrTable,
            dialogFormConfig: ywrDialogForm, // 表单配置
          },
          {
            type: 'table-sqr',
            category: '6',
            tableTitle: '债务人(贷款者)',
            tableColumnConfig: column.zwrTable,
            dialogFormConfig: zwrDialogForm, // 表单配置
          },
          {
            type: 'table-qlxx',
            key: 'qlxxExMhs',
            tableTitle: '不动产情况(单位:平方米、万元)',
            tableColumnConfig: column.dyscqlxxTable,
            dialogFormConfig: otherqlxxDialogForm, // 表单配置
          },
          {
            type: 'form',
            key: 'qlxxExMhs',
            tableTitle: '不动产情况(单位:平方米、万元)',
            formConfig: fwbgQlxxForm,
          },
          {
            type: 'form',
            key: 'qlxxEx',
            tableTitle: '抵押信息(单位:平方米、万元)',
            formConfig: zjdyqscQlxxExForm, // 表单配置
          },
        ],
      },
    ],
  },
  {
    name: '抵押权变更(土地)',
    code: 'N100304',
    data: [
      {
        name: '抵押权变更(土地)',
        code: 'N100304',
        config: [
          {
            type: 'table-sqr',
            category: '4',
            tableTitle: '抵押权人',
            tableColumnConfig: column.qlrTable,
            dialogFormConfig: qlrDialogForm, // 表单配置
          },
          {
            type: 'table-sqr',
            category: '5',
            tableTitle: '抵押人',
            tableColumnConfig: column.ywrTable,
            dialogFormConfig: ywrDialogForm, // 表单配置
          },
          {
            type: 'table-sqr',
            category: '6',
            tableTitle: '债务人(借款者)',
            tableColumnConfig: column.zwrTable,
            dialogFormConfig: zwrDialogForm, // 表单配置
          },
          {
            type: 'table-qlxx',
            key: 'qlxxExMhs',
            tableTitle: '不动产情况(单位:平方米、万元)',
            tableColumnConfig: column.dyscqlxxTable,
            dialogFormConfig: otherqlxxDialogForm, // 表单配置
          },
          {
            type: 'form',
            key: 'qlxxExMhs',
            tableTitle: '不动产情况(单位:平方米、万元)',
            formConfig: fwbgQlxxForm,
          },
          {
            type: 'form',
            key: 'qlxxEx',
            tableTitle: '抵押信息(单位:平方米、万元)',
            formConfig: dybgQlxxExForm, // 表单配置
          },
        ],
      },
    ],
  },
  {
    name: '抵押权更正(土地)',
    code: 'N100302',
    data: [
      {
        name: '抵押权更正(土地)',
        code: 'N100302',
        config: [
          {
            type: 'table-sqr',
            category: '4',
            tableTitle: '抵押权人',
            tableColumnConfig: column.qlrTable,
            dialogFormConfig: qlrDialogForm, // 表单配置
          },
          {
            type: 'table-sqr',
            category: '5',
            tableTitle: '抵押人',
            tableColumnConfig: column.ywrTable,
            dialogFormConfig: ywrDialogForm, // 表单配置
          },
          {
            type: 'table-sqr',
            category: '6',
            tableTitle: '债务人(借款者)',
            tableColumnConfig: column.zwrTable,
            dialogFormConfig: zwrDialogForm, // 表单配置
          },
          {
            type: 'table-qlxx',
            key: 'qlxxExMhs',
            tableTitle: '不动产情况(单位:平方米、万元)',
            tableColumnConfig: column.dyscqlxxTable,
            dialogFormConfig: otherqlxxDialogForm, // 表单配置
          },
          {
            type: 'form',
            key: 'qlxxExMhs',
            tableTitle: '不动产情况(单位:平方米、万元)',
            formConfig: fwbgQlxxForm,
          },
          {
            type: 'form',
            key: 'qlxxEx',
            tableTitle: '抵押信息(单位:平方米、万元)',
            formConfig: dybgQlxxExForm, // 表单配置
          },
        ],
      },
    ],
  },
  {
    name: '证书补证登记',
    code: 'N900101',
    data: [
      {
        name: '证书补证登记',
        code: 'N900101',
        config: [
          {
            type: 'table-sqr',
            category: '0',
            tableTitle: '权利人',
            tableColumnConfig: column.qlrTable,
            dialogFormConfig: qlrDialogForm, // 表单配置
          },
          {
            type: 'table-sqr',
            category: '1',
            tableTitle: '原权利人',
            tableColumnConfig: column.ywrTable,
            dialogFormConfig: ywrDialogForm, // 表单配置
          },
          {
            type: 'table-qlxx',
            key: 'qlxxExMhs',
            tableTitle: '不动产情况',
            tableColumnConfig: column.qlxxTable,
            dialogFormConfig: bzhzQlxxForm, // 表单配置
          },
          {
            type: 'form',
            key: 'qlxxExMhs',
            tableTitle: '不动产情况',
            formConfig: bzhzQlxxForm,
          },
          {
            type: 'form',
            key: 'qlxxEx',
            tableTitle: '其它信息',
            formConfig: fwzyQlxxExForm, // 表单配置
          },
        ],
      },
    ],
  },
  {
    // 一般抵押权首次
    name: '抵押权首次登记（联合抵押）',
    code: 'H100301',
    data: [
      {
        name: '抵押权首次登记',
        code: 'N100301',
        config: [
          {
            type: 'table-sqr',
            category: '4',
            tableTitle: '抵押权人(银行)',
            tableColumnConfig: column.qlrTable,
            dialogFormConfig: qlrYBDYSCDialogForm, // 表单配置
          },
          {
            type: 'table-sqr',
            category: '5',
            tableTitle: '抵押人(房屋所有者)',
            tableColumnConfig: column.ywrTable,
            dialogFormConfig: ywrDialogForm, // 表单配置
          },
          {
            type: 'table-sqr',
            category: '6',
            tableTitle: '债务人',
            tableColumnConfig: column.zwrTable,
            dialogFormConfig: zwrDialogForm, // 表单配置
          },
          {
            type: 'table-qlxx',
            key: 'qlxxExMhs',
            tableTitle: '不动产情况(单位:平方米、万元)',
            tableColumnConfig: column.dyscqlxxTable,
            dialogFormConfig: otherqlxxDialogForm, // 表单配置
          },
          {
            type: 'form',
            key: 'qlxxExMhs',
            tableTitle: '不动产情况(单位:平方米、万元)',
            formConfig: dyscQlxxForm,
          },
          {
            type: 'form',
            key: 'qlxxEx',
            tableTitle: '抵押信息(单位:平方米、万元)',
            formConfig: ybdyqscQlxxExForm, // 表单配置
          },
        ],
      }
    ],
  },
  {
    name: '在建工程一般抵押',
    code: 'N300098',
    data: [
      {
        name: '在建工程一般抵押',
        code: 'N300098',
        config: [
          {
            type: 'table-sqr',
            category: '4',
            tableTitle: '抵押权人(法人、代理人信息)',
            tableColumnConfig: column.qlrTable,
            dialogFormConfig: qlrDialogForm, // 表单配置
          },
          {
            type: 'table-sqr',
            category: '5',
            tableTitle: '抵押人(法人、代理人信息)',
            tableColumnConfig: column.ywrTable,
            dialogFormConfig: ywrDialogForm, // 表单配置
          },
          {
            type: 'table-sqr',
            category: '6',
            tableTitle: '债务人(法人、代理人信息)',
            tableColumnConfig: column.zwrTable,
            dialogFormConfig: zwrDialogForm, // 表单配置
          },
          {
            type: 'table-qlxx',
            key: 'qlxxExMhs',
            tableTitle: '不动产情况(单位:平方米、万元)',
            tableColumnConfig: column.dyscqlxxTable,
            dialogFormConfig: otherqlxxDialogForm, // 表单配置
          },
          {
            type: 'form',
            key: 'qlxxExMhs',
            tableTitle: '不动产情况(单位:平方米、万元)',
            formConfig: fwbgQlxxForm,
          },
          {
            type: 'form',
            key: 'qlxxEx',
            tableTitle: '抵押信息(单位:平方米、万元)',
            formConfig: zjdyqscQlxxExForm, // 表单配置
          },
        ],
      },
    ],
  },
];
export default sqbConfig;
